export default __webpack_public_path__ + "static/media/2010-IMcover.b6bced86.jpg";